import { FETCH_USER_CREDENTIALS } from './types';
import api from '../apis/api';
import getMessageFromApiError from '../util/getMessageFromApiError';
import { setErrorMessage } from './errorMessage';

export const fetchCredentials = (user_id) => async (dispatch) => {
  if (!user_id) {
    throw new Error('user_id is required');
  }
  try {
    const res = await api.get(`/project/${user_id}/credentials/`);
    dispatch({
      type: FETCH_USER_CREDENTIALS,
      payload: res.data,
    });
  } catch (error) {
    const message = getMessageFromApiError(error);
    dispatch(setErrorMessage(message));
    throw new Error(`API Error - ${message}`);
  }
};

export const removeCredential = (user_id, type) => async (dispatch) => {
  if (!user_id) {
    throw new Error('user_id is required');
  }
  try {
    await api.delete(`/project/${user_id}/credentials/${type}`);
    dispatch(fetchCredentials(user_id));
  } catch (error) {
    const message = getMessageFromApiError(error);
    dispatch(setErrorMessage(message));
    throw new Error(`API Error - ${message}`);
  }
};
export const putCredential = (user_id, values) => async (dispatch) => {
  if (!user_id) {
    throw new Error('user_id is required');
  }
  try {
    await api.put(`/project/${user_id}/credentials/${values.type}`, values);
    dispatch(fetchCredentials(user_id));
  } catch (error) {
    const message = getMessageFromApiError(error);
    dispatch(setErrorMessage(message));
    throw new Error(`API Error - ${message}`);
  }
};
